module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM14 21a1 1 0 0 1-1 1h-3v4H8V6h2v4h3a1 1 0 0 1 1 1v10zm10-2a1 1 0 0 1-1 1h-3v6h-2V6h2v6h3a1 1 0 0 1 1 1v6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/align-left-edges-1.js
// module id = 986
// module chunks = 14